import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Cppsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cif(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  

return(
    <div>
      
      <Sides/>
       <Helmet>
 
 <title>if statement in c++ tutorial For Beginners</title>
 <meta name="description" content="if statement in c++ tutorial for beginners.If is used for making a decision.If and else can be a block statementCodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,cpp if,if else statement c++,c++ remove_if,c++ if loop,find_if c++,cpp if else,programming language tutorial for begineers,cpp ifdef,learn code in free,c++ programming tutorial for beginners,learn code in free online,if in cpp programming,if,in in c++,if statement in cpp,c++ programming if statement" />
 <link rel="canonical" href="https://www.codeexampler.com/cpp-if" />
 </Helmet>


 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">If Statement in c++
 </h1>
 <div className="first">
        <a href="/cpp-control-structure">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-if-else">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<p className="mt-4 para">If Statement use for making a decision. If and else can be a block statement and <a href="https://www.codeexampler.com/cpp-if-else">else if c++ Statement</a> 
</p>



<h2 className='heading'>If statement in c++ syntax:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%',paddingLeft:'2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh'}}>
          <code >{"\n"}
          
          <span className="qwerty-7">if</span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-5">condition</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3">&#123;</span>

            {"\n"}
          
            <span className="qwerty-10">{" "}body</span>
            {"\n"}
            
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


      <h2 className='headings'>Q-Write a program to input a number and check this number is more than or equal to 100?</h2>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%',paddingLeft:'2%', borderRadius: '20px' }}>
        <pre  style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}
            <span className="qwerty-8">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-4">int </span>
            <span className="qwerty-10">a;</span>
            {"\n"}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-10"> "enter a number";</span>
            {"\n"}
            <span className="qwerty">cin </span>
            <span className="qwerty-3">&#62;&#62; </span>
            <span className="qwerty-10">a; </span>
            {"\n"}
            <span className="qwerty-2">if </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3">&#62;=</span>
            <span className="qwerty-9">100</span>
            <span className="qwerty-3">) </span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>

            {"\n"}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-10"> "This no is greater than 100"; </span>
            {"\n"}
            <span className="qwerty-3">&#125;</span>
            {"\n"}
            <span className="qwerty-7"> return </span>
            <span className="qwerty-10">0; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="head3">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%',paddingLeft:'2%', borderRadius: '20px' }}>
          <pre className="python-exec" style={{ maxHeight: '600px' }}>
            <code className="python hljs">
              {"\n"}
              <span className="qwerty-10">enter a number</span>
              <span className="qwerty-6"> 450</span>
              {"\n"}
              {"\n"}
              <span className="qwerty-5">This no is greater than</span>
              <span className="qwerty-6"> 100</span>
              {"\n"}
          </code>{"\n"}</pre>
        </div>
      </div>
 







<h2 className='headings'>Q-Write a program to input a number and check greater and lesser no?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%',paddingLeft:'2%', borderRadius: '20px' }}>
        <pre  style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}
            <span className="qwerty-8">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{""}
            <span className="qwerty-8">int </span>
            <span className="qwerty-10">a;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-10">"enter a value of a";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cin </span>
            <span className="qwerty-3">&#62;&#62; </span>
            <span className="qwerty-10">a; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-2">if </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3">&#62;=</span>
            <span className="qwerty-9">500</span>
            <span className="qwerty-3">) </span>
            {"\n"}{"\n"}{"   "} 
            <span className="qwerty-3"> &#123; </span>

            {"\n"}{"\n"}{"   "}
            <span className="qwerty-7">cout </span>
     
            <span className="qwerty-10">  &#60;&#60; a &#60;&#60; " is greater than 500"; </span>
            {"\n"}{"\n"}{"    "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-2">if </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-9">500</span>
            <span className="qwerty-3">) </span>
            {"\n"}{"\n"}{"   "}
            <span className="qwerty-3"> &#123; </span>

            {"\n"}{"\n"}{"    "}
            <span className="qwerty-7">cout </span>
      
            <span className="qwerty-10"> &#60;&#60; a &#60;&#60; " is less than 500"; </span>
            {"\n"}{"\n"}{"    "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-7"> return </span>
            <span className="qwerty-10">0; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="head3">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%',paddingLeft:'2%', borderRadius: '20px' }}>
          <pre className="python-exec" style={{ maxHeight: '600px' }}>
            <code className="python hljs">
              {"\n"}
              <span className="qwerty-10">enter a value of a</span>
              <span className="qwerty-6"> 36</span>
              {"\n"}
              {"\n"}
              <span className="qwerty-10">a </span>
              <span className="qwerty-6">36 </span>
              <span className="qwerty-10">is less than</span>
              <span className="qwerty-4"> 500</span>
              {"\n"}{"        "}
            </code>{"\n"}</pre>
        </div>
      </div>




<h2 className='headings'>Q-Write a program to input a number and check no is greater or lesser?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3">,</span>
            <span className="qwerty-10">b</span>
            <span className="qwerty-3">,</span>
            <span className="qwerty-10">c</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">=</span>
            <span className="qwerty-5"> 100</span>
            <span className="qwerty-3">,</span>
            <span className="qwerty-10"> b </span>
            <span className="qwerty-3">=</span>
            <span className="qwerty-5"> 200</span>
            <span className="qwerty-3">,</span>
            <span className="qwerty-10"> c </span>
            <span className="qwerty-3">=</span>
            <span className="qwerty-5"> 400</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-5">if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">&#62; </span>
            <span className="qwerty-10">b</span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10"> a </span>
            <span className="qwerty-5">is</span>
            <span className="qwerty-10"> greater </span>
            <span className="qwerty-5">than </span>
            <span className="qwerty-10">b\n </span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-5">if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">&#60; </span>
            <span className="qwerty-10">b</span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10"> b </span>
            <span className="qwerty-5">is</span>
            <span className="qwerty-10"> greater </span>
            <span className="qwerty-5">than </span>
            <span className="qwerty-10">a\n</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-5">if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">&#60; </span>
            <span className="qwerty-10">c</span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10"> c </span>
            <span className="qwerty-5">is</span>
            <span className="qwerty-10"> greater </span>
            <span className="qwerty-5">than </span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}
            <span className="qwerty-5">return </span>
            <span className="qwerty-10">0; </span>
            {"\n"}{"  "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
              {"\n"}{"\n"}
              <span className="qwerty-10">b</span>
              <span className="qwerty-5"> is</span>
              <span className="qwerty-10"> greater </span>
              <span className="qwerty-5">than </span>
              <span className="qwerty-4">a</span>
              {"\n"}
              {"\n"}
              <span className="qwerty-10">c</span>
              <span className="qwerty-5"> is</span>
              <span className="qwerty-10"> greater </span>
              <span className="qwerty-5">than </span>
              <span className="qwerty-4">a</span>
              {/* <span className="qwerty-10"> 1000</span> */}
         
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>


<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/cpp-control-structure">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-if-else">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Cif;